<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${test_process.name}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit prep process'">
      <template #gated-content>
        <test-process-form :test_process="test_process" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestProcessForm from "@/components/lab/testprocess/TestProcessForm";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testProcessNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const TestProcessRepository = LabRepositoryFactory.get("testProcess");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestProcessEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestProcessForm,
  },
  data() {
    return {
      loading: true,
      test_process_id: this.$route.params.test_process_id || null,
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
      test_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/test-processes",
            title: "Test process list",
          },
          {
            icon: "fa-eye",
            linkto: `/test-processes/${this.test_process_id}`,
            title: "View test processes",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        const { data } = await TestProcessRepository.update(
          this.test_process_id,
          {
            ...form_data,
            sample_types: form_data.sample_types.map((id) => {
              return {
                id,
              };
            }),
            laboratory_id: this.laboratory_id,
          }
        );

        this.editSuccess();

        this.$router.push(`/test-processes/${data.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Process update Failed.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.test_process = await getModel({
      model_type: "test_process",
      id: this.test_process_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: testProcessNotifications,
};
</script>
